import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import "../css/Login.css";

export default function ConfirmPopup(props) {

  const {open, icon, title, msg, confirm, cancel, tabName} = props;

  return (
    <div>
      <Dialog open={open} className="s" {...(title ? { PaperProps: { style: { maxWidth: '460px', width: '460px' } } } : {})}>
        {title ? (
          <DialogTitle className='dialogTitle dialogTitleWarning'>
            <span className="WarningTriangleIcon">&#9888;</span>
            <span className="ConfirmWarningTitle">{title}</span>
          </DialogTitle>
        ) : (
          <DialogTitle className='dialogTitle'><div className="buttonDiv WarningIconBorder">{icon}</div></DialogTitle>
        )}
        <DialogContent className='dialogContent'>
          {!title && <h6 className="ConfirmTitleHeader"></h6>}
          <p className={title ? "ConfirmWarningPara mx-2 mb-2" : "ConfirmTitlePara"}>{msg}</p>
        </DialogContent>
        <DialogActions className="dialogActions">
          <div className="buttonDiv">
            <button className={`PopupButton ${title ? 'Yes' : 'No'} z-depthButton`} onClick={() => confirm(tabName)}>
              YES
            </button>
            <button className="PopupButton No z-depthButton" onClick={() => cancel(tabName)}>
              NO
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}